import axios from "axios";
import React, { Component } from "react";
import ArticleForm from "../components/ArticleForm";
import Loading from "../components/Loading";
import PageNav from "../partials/PageNav";
import ArticleContentForm from "../components/ArticleContentForm";
import { Link } from "react-router-dom";

class Article extends Component {
  state = {
    isModal: false,
    isModalContent: false,
    formData: null,
    articles: [],
    loading: false,
  };

  componentDidMount() {
    this.getArticles();
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  async getArticles( status = "actif") {
    this.setState({
      loading: false,
    });

    var society = localStorage.getItem("society")
      ? JSON.parse(localStorage.getItem("society"))
      : {};
    var society = society.userprofile
      ? society.userprofile.profile
        ? society.userprofile.profile.society
          ? society.userprofile.profile.society.id
          : null
        : null
      : null;

    var articles = await axios.get("articles/" + society + "/" + status);
    if (articles.status === 200) {
      this.setState({ articles: articles.data.sort((a, b) => a.createdAt < b.createdAt ? -1 : 1), loading: true });
    }
  }

  showModal = (data = null) => {
    this.setState({
      isModal: !this.state.isModal,
      formData: data,
    });
    this.getArticles();
  };

  showModalContent = (data = null) => {
    this.setState({
      isModalContent: !this.state.isModalContent,
      formData: data,
    });
    this.getArticles();
  };

  delete = (article) => {
    axios
      .delete("articles/" + article)
      .then((response) => {
        this.getArticles();
      })
      .catch((error) => {});
  };

  handleCheck(val) {
    var permissions = JSON.parse(localStorage.getItem("permissions"))
      ? JSON.parse(localStorage.getItem("permissions"))
      : [];
    return permissions.some((item) => val === item.name);
  }

  
  render() {
    let pageNav = PageNav("liste et paramètrage  des articles",  "/articles", "/logo192.png", "Articles", "Liste de nos articles");
  
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    let createdAt = new Date();
    var articles = this.state.articles
      .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
      .map((article) => {
        createdAt = new Date(article.createdAt).toUTCString()
        return (
          <div className="col-md-3 " key={article.id}>
            <article>
              <div className="post-img p-2 rounded rounded-3">
                <Link  to={"/articles/" + article.id} title={article.title}>
                  <img
                    src={ article.category.id != process.env.REACT_APP_ID_DOCUMENTATION ?  article.images.image : process.env.REACT_APP_BEYEGROUP + "/img/background.png" }
                    alt={article.images.image}
                    className="img-fluid"
                    style={{ width : 307 +"px", height : 204 + "px" }}
                  />
                </Link>
              </div>

              <p className="post-category" style={{ fontSize: 12 }}>
              <i className={article?.category.icone}></i><b>{article?.category.name}</b>
                <small style={{ fontSize: 10, marginLeft : 10 }}>
                <i className={"bi bi-clock ms-2 text-primary"}></i><time dateTime={createdAt}>{new Date(createdAt).toUTCString()}</time>
                </small>
                <i className="bi bi-emoji-heart-eyes ms-2 text-primary"></i>{ article.view }
              </p>

              <h6 className="title  text-truncate">
                <Link to={"/articles/" + article.id} title={article.title} className="font-normal h6">
                  {article.title}
                </Link>
              </h6>

              <div className="d-flex align-items-center">
                <img
                  src={article?.user.avatar}
                  alt={article?.user.name}
                  className="img-fluid post-author-img flex-shrink-0"
                />
                <div className="post-meta">
                  <p className="post-author-list"> {article?.user.name} </p>
                </div>
              </div>

              {this.handleCheck("modifier article") == true &&
                (user.id == article?.user.id || this.handleCheck("admin") == true ) && (
                  <a
                    href="#"
                    onClick={() => this.showModal(article)}
                    className="me-2 text-dark"
                  >
                    <i className="bi bi-pen "></i> Edit
                  </a>
                )}

              {this.handleCheck("modifier article") == true &&
              (user.id == article?.user.id || this.handleCheck("admin") == true ) && (
                  <a
                    href="#"
                    onClick={() => this.showModalContent(article)}
                    className="me-2 text-dark"
                  >
                    <i className="bi bi-pen "></i> Content
                  </a>
                )}

              {this.handleCheck("supprimer article") == true &&
              (user.id == article?.user.id || this.handleCheck("admin") == true ) && (
                  <a
                    href="#"
                    onClick={() => this.delete(article.id)}
                    className="me-2 text-danger"
                  >
                    {" "}
                    Effacer
                  </a>
                )}
            </article>
          </div>
        );
      });
    return (
      <main id="main">
        {pageNav}
        <div className="container">
          <div className="row col-sm-12">
            <div className="page-title-box">
                <div className="btn-toolbar mb-2 mb-md-0 d-end float-end">
                  
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary m-1"
                    onClick={() => this.getArticles("actif")}
                  >
                    <i className="bi bi-app font-18"></i> articles actifs
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary m-1"
                    onClick={() => this.getArticles("desactive")}
                  >
                    <i className="bi bi-app-indicator text-danger font-18"></i> article non actif
                  </button>

              {this.handleCheck("ajouter article") == true && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary m-1"
                    onClick={() => this.showModal(null)}
                  >
                    <i className="bi bi-plus font-18"></i> Nouvel article
                  </button>
              )}
                </div>
            </div>
            {!this.state.loading && <Loading />}
          </div>
          <section id="blog" className="blog">
            <div className="container" data-aos="fade-up">
              <div className="row gy-4 posts-list">{articles}</div>
            </div>
          </section>
        </div>

        <ArticleForm
          isModal={this.state.isModal}
          formData={this.state.formData}
          showModal={this.showModal}
        />
        <ArticleContentForm
          isModal={this.state.isModalContent}
          article={this.state.formData}
          showModal={this.showModalContent}
        />
      </main>
    );
  }
}
export default Article;
